import { render, staticRenderFns } from "./SubscriptionAffiliate.vue?vue&type=template&id=45314adc&scoped=true&"
import script from "./SubscriptionAffiliate.vue?vue&type=script&lang=js&"
export * from "./SubscriptionAffiliate.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionAffiliate.vue?vue&type=style&index=0&id=45314adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45314adc",
  null
  
)

export default component.exports